import React from "react";
import { Row, Col, Form, Button } from "react-bootstrap";
import { HiOutlineTrash } from "react-icons/hi";
import FaqAnswerInput from "./FaqAnswerInput";

/**
 * Dynamic add/remove list of {question, answer} pairs, shown on the blog
 * detail page as an accordion. Kept as a clean array of plain objects from
 * the start — no ad-hoc array/object type juggling.
 */
const FaqEditor = ({ faqs, onChange }) => {
  const items = Array.isArray(faqs) ? faqs : [];

  const updateItem = (index, field, value) => {
    const next = [...items];
    next[index] = { ...next[index], [field]: value };
    onChange(next);
  };

  const addItem = () => {
    onChange([...items, { question: "", answer: "" }]);
  };

  const removeItem = (index) => {
    onChange(items.filter((_, i) => i !== index));
  };

  return (
    <div>
      {items.map((item, index) => (
        <div key={index} className="border rounded p-3 mb-3 bg-light-subtle">
          <Row className="mb-2 align-items-start">
            <Col md={11}>
              <Form.Label className="fw-bold">Question {index + 1}</Form.Label>
              <Form.Control
                type="text"
                placeholder="e.g. How much does a banquet hall in Coimbatore cost?"
                value={item.question || ""}
                onChange={(e) => updateItem(index, "question", e.target.value)}
              />
            </Col>
            <Col md={1} className="d-flex align-items-end justify-content-end pb-1">
              <HiOutlineTrash
                title="Remove FAQ"
                style={{ cursor: "pointer", fontSize: 18, color: "#c0392b" }}
                onClick={() => removeItem(index)}
              />
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <Form.Label className="fw-bold">Answer</Form.Label>
              <FaqAnswerInput
                value={item.answer}
                onChange={(value) => updateItem(index, "answer", value)}
                placeholder="Write the answer here..."
              />
            </Col>
          </Row>
        </div>
      ))}

      <Button variant="outline-primary" size="sm" onClick={addItem} type="button">
        + Add FAQ
      </Button>
    </div>
  );
};

export default FaqEditor;
